import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { MechanicTimeCode, MechanicTimeCodeDetailsListViewModel } from '../business-entities/mechanic-time-code-model';
import { MechanicTimeCodeDataService } from '../data-services/mechanic-time-code-data.service';


@Injectable({
  providedIn: 'root'
})

export class MechanicTimeCodeBusinessService {
  constructor(private service: MechanicTimeCodeDataService) {
  }
  isEdit: boolean = false;
  mechanicTimeCodeId: number
  DealerSpecialToolId: number
  mechanicTimeCodeList: MechanicTimeCodeDetailsListViewModel;
  mechanicTimeCode: MechanicTimeCode;
  //specialTool: SpecialTool;
  async getMechanicTimeCodeList(DealerId: string,language:string): Promise<MechanicTimeCodeDetailsListViewModel> {
    await this.service
      .getMechanicTimeCodeList(DealerId,language)
      .then(
        (res: GenericResponse<MechanicTimeCodeDetailsListViewModel>) => {
          this.mechanicTimeCodeList = res.responseObject;
        }
      );
    return this.mechanicTimeCodeList;
  }

  addMechanicTimeCodeList(model: any): Promise<any> {
    return this.service.addMechanicTimeCodeList(model);
  }
  async getMechanicTimeCodeById(Id: number) {
    await this.service
      .getMechanicTimeCodeById(Id)
      .then(
        (res: GenericResponse<MechanicTimeCode>) => {
          this.mechanicTimeCode = res.responseObject;
        }
      );
    return this.mechanicTimeCode;
  }

  editMechanicTimeCode(model: any): Promise<any> {
    return this.service.editMechanicTimeCode(model);
  }

  getTimeStampSummary(workorderNo: string):Promise<any>{
    return this.service.getTimeStampSummary(workorderNo);
  }

  updateJobStatus(model:any):Promise<any>
  {
    return this.service.updateJobStatus(model);
  }

}
